module.exports = __webpack_public_path__ + "img/tp-keypal-card-en.1fe84aa0.png";